import { getActiveUsers } from 'utils';

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IDBUser } from 'constants/types';
import { useVoteResultsQuery } from 'services/voteManagement';

import UserIcon from '../UserIcon';
import {
  ReactionItem,
  ReactionListContainer,
  StyledModal,
  UserItem,
  UserList,
} from './styles';

interface VoteResultsModalProps {
  isVisible: boolean;
  onClose: () => void;
  pollId: string;
}

const VoteResultsModal: React.FC<VoteResultsModalProps> = ({
  isVisible,
  onClose,
  pollId,
}) => {
  const { t } = useTranslation('forum');
  const { data: voteResults } = useVoteResultsQuery(pollId, {
    skip: !isVisible,
  });
  const [activeOption, setActiveOption] = useState<string | null>('All');
  const activeUsers = getActiveUsers(voteResults, activeOption);

  return (
    <StyledModal
      title={t('vote_results')}
      visible={isVisible}
      onCancel={onClose}
      footer={null}
    >
      {voteResults && (
        <>
          <ReactionListContainer>
            <ReactionItem
              key="All"
              isActive={activeOption === 'All'}
              onClick={() => setActiveOption('All')}
            >
              {t('all_votes', { count: voteResults.totalVotes })}
            </ReactionItem>

            {voteResults.options.map((option: any) => (
              <ReactionItem
                key={option.optionId}
                isActive={activeOption === option.optionId}
                onClick={() => setActiveOption(option.optionId)}
              >
                {option.text}: {option.voteCount}
              </ReactionItem>
            ))}

            <ReactionItem
              key="Non-Voters"
              isActive={activeOption === 'Non-Voters'}
              onClick={() => setActiveOption('Non-Voters')}
            >
              {t('not_voted', { count: voteResults.nonVoters.length })}
            </ReactionItem>
          </ReactionListContainer>

          <UserList>
            {activeUsers.map((user: IDBUser) => (
              <UserItem key={user._id}>
                <div>
                  <UserIcon
                    firstName={user.firstName}
                    lastName={user.lastName}
                    userRole={user.role}
                    width="40"
                    height="40"
                  />
                </div>
                <div>
                  {user.firstName} {user.lastName}
                </div>
              </UserItem>
            ))}
          </UserList>
        </>
      )}
    </StyledModal>
  );
};

export default VoteResultsModal;
